import { render, staticRenderFns } from "./survey.component.html?vue&type=template&id=247bf6ea&scoped=true&external"
import script from "./survey.component.ts?vue&type=script&lang=ts&external"
export * from "./survey.component.ts?vue&type=script&lang=ts&external"
import style0 from "./survey.component.scss?vue&type=style&index=0&id=247bf6ea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247bf6ea",
  null
  
)

export default component.exports